import { memo } from "react"
import { makeStyles } from "tss-react/mui"
import { Box, Stack } from "@mui/material"
import { ProductsTableItem } from "../../../../../../modules/merchant/admin/products/productsTypes"
import { ProductDetailsContent } from "./ProductDetailsContent"
import { ProductTopInfo } from "./ProductTopInfo"
import { ProductCounter } from "./ProductCounter"
import { ProductAmount } from "./ProductAmount"

export const CARD_BORDER_RADIUS = "1rem"

const useStyles = makeStyles()((theme) => ({
    container: {
        width: "14rem",
        position: "relative",
        borderRadius: CARD_BORDER_RADIUS,
        background: theme.palette.common.white,
        display: "flex",
        flexDirection: "column",
    },
    cardContent: {
        padding: ".75rem",
        color: theme.palette.text.primary,
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "7.75rem",
        maxHeight: "7.75rem"
    },
}))

interface ProductProps {
    product: ProductsTableItem
    addToBasket: (product: ProductsTableItem, quantity: number) => void
    quantity: number
    handleFavoriteProduct: (id: number, makeFavorite: boolean) => Promise<boolean>
    searchRegex: RegExp | undefined
    isListView: boolean
}

export const Product = memo(
    ({ product, handleFavoriteProduct, addToBasket, quantity, searchRegex, isListView }: ProductProps) => {
        const { classes } = useStyles()

        const handleQuantityChange = (newQuantity: number) => {
            addToBasket(product, newQuantity)
        }

        return (
            <Box className={classes.container}>
                {!isListView && (
                    <ProductTopInfo
                        productId={product.id}
                        imageUrl={product?.productPhoto?.url}
                        offerDetails={product?.offerDetails}
                        isFavoriteProduct={!!product?.userDetails?.isFavorite}
                        handleFavoriteProduct={handleFavoriteProduct}
                    />
                )}

                <Stack gap="0.375rem" className={classes.cardContent}>
                    <ProductDetailsContent
                        product={product}
                        searchRegex={searchRegex}
                        marketingTag={product?.productDescription?.marketingTag}
                        productsOnSale={product?.offerDetails?.productsOnSale}
                    />
                    <Stack
                        flexDirection="row"
                        flexWrap="nowrap"
                        gap=".75rem"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <ProductAmount price={product.price} />
                        <ProductCounter count={quantity} handleCounter={handleQuantityChange} />
                    </Stack>
                </Stack>
            </Box>
        )
    },
)
